import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import { useHistory } from "react-router-dom";
import {useEffect, useState} from 'react';
import {useApi} from "../provider/ApiProvider";
import {Button, Popconfirm, Switch} from 'antd';
import {DeleteOutlined, RightOutlined} from "@ant-design/icons";
import moment from 'moment';
import {render} from "@testing-library/react";


export default function BlogsPage(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Teknopark',
            render: (record) => record.Company.name
        },
        {
            title: 'Yayınlanma Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (record) => moment(record.createdAt).format("DD/MM/YYYY")
        },
        {
            title: 'Son Güncelleme',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (record) => moment(record.updatedAt).format("DD/MM/YYYY")

        },
        // {
        //     title: 'Durum',
        //     key: 'isActive',
        //     render: (record) => (
        //         <Switch defaultChecked={record.isActive} onChange={(checked) => {
        //             updateStatus(record.id, checked);
        //         }}/>
        //     )
        // },
        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                    <Button style={{marginLeft: '4%'}} onClick={() => clickRow(record)}>
                        <RightOutlined />
                    </Button>

                </div>
            )
        }

    ];

    let history = useHistory();
    const {api} = useApi();
    const [blogs, setBlogs] = useState({totalCount: 0, items: []})

    useEffect(() => {
        load({skip: 0, max: 10})
    },[])

    async function load(params){
        await api.get('/blog/all', params).then(resp => {
            setBlogs({totalCount: resp.totalCount, items: resp.data});
        })
    }

    function clickRow(item){
        history.push("/blog/add/" + item.id);
    }

    async function updateStatus(id, value){
        await api.put('/blog/update/' + id, {isActive: value}).then(resp => {
            load();
        })
    }

    async function deleteRow(id){
        await api.delete('/blog/delete/' + id).then(resp => {
            load();
        })
    }

    function tableChange(filter){
        let newFilter = {
            skip: (filter.page - 1) * filter.perPage,
            max: filter.perPage
        }
        load(newFilter);
    }

    return (
        <LayoutComponent title={"Bloglar"} links={
            [
                {
                    title: 'Bloglar',
                    url: '/blogs'
                },

            ]}
        >
            <TableComponent
                columns={columns}
                data={blogs}
                clickAddButton={() => {history.push("/blog/add")}}
                onChange={tableChange}
            />
        </LayoutComponent>
    )
}